import { useDashboard } from '@utmb/contexts/DashboardContext';
import { ReactElement, useState } from 'react';
import { ModalEmailAccount } from './modals/ModalEmailAccount';
import { MergeAccountNotification } from '../my-utmb/merge-account-notification/MergeAccountNotification';

export const EmailModalNotificationContainer = (): ReactElement => {
    const [isEmailAccountModalOpen, setIsEmailAccountModalOpen] = useState<boolean>(false);
    const { dashboardMember } = useDashboard();

    return (
        <>
            <ModalEmailAccount
                isOpen={isEmailAccountModalOpen}
                close={() => {
                    setIsEmailAccountModalOpen(false);
                }}
            />
            <MergeAccountNotification
                transfer={dashboardMember?.transfer}
                callback={() => {
                    setIsEmailAccountModalOpen(true);
                }}
            />
        </>
    );
};
